// vim: set ts=2 sts=2 sw=2 et:

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";

import type { GlobalState } from "../../types/stateTypes";
import { saveOpenlifterFile } from "../handoff/saveOpenlifterFile";
import { isWrpfChromeFreePath } from "../isWrpfChromeFreePath";
import { isPersistFailing, subscribePersistHealth } from "./persistHealth";

type Props = { global: GlobalState };

/** Aviso fijo cuando el navegador no pudo guardar el torneo: recargar o cerrar perdería lo último. */
const PersistFailureBannerInner = ({ global }: Props) => {
  const location = useLocation();
  const [failing, setFailing] = useState(isPersistFailing());

  useEffect(() => subscribePersistHealth(setFailing), []);

  if (!failing || isWrpfChromeFreePath(location.pathname)) return null;

  return (
    <Alert variant="danger" className="mb-0 rounded-0 text-center" role="alert">
      <strong>OpenLifter no pudo guardar el torneo en este navegador.</strong> No recargues ni cierres esta pestaña: se
      perdería lo último. Guardá el archivo ahora y avisá al equipo técnico.{" "}
      <Button variant="light" size="sm" className="ml-2" onClick={() => saveOpenlifterFile(global)}>
        Guardar como
      </Button>
    </Alert>
  );
};

const mapState = (state: GlobalState): Props => ({ global: state });

export default connect(mapState)(PersistFailureBannerInner);
